import Vue from 'vue'
import api from '@/api'

export default {

	namespaced: true,

	state: {
		data: {},
		status: false,
		plan: false,
		reference: false,
		capture: false
	},

	getters: {

		onboarding: function(state) {

			return state.data.onboarding
			
		},

		organisation: function(state) {

			return state.data.organisation
			
		},

		membership: function(state) {

			return state.data.membership
			
		},

		inputs: function(state) {

			return state.data.capture
			
		},

		plans: function(state) {

			return state.data.plans
			
		},

		status: function(state) {

			return state.status

		},

		plan: function(state) {

			return state.plan

		},

		reference: function(state) {

			return state.reference

		},

		capture: function(state) {

			return state.capture

		}

	},

	mutations: {

		set: function(state, data) {

			Vue.set(state, 'data', data)

		},
	
		status: function(state, data) {

			state.status = data

		},
	
		capture: function(state, data) {

			state.capture = data

		},
	
		plan: function(state, data) {

			state.plan = data

		},
	
		reference: function(state, data) {

			state.reference = data

		}

	},

	actions: {

		retrieve: function(context, secret) {

			return api.get('intent', {
				secret: secret
			}).then(function(json) {

				context.commit('status', json.status)
				context.commit('reference', json.reference)
				context.commit('capture', json.data.capture)
				context.commit('plan', json.data.plan)

			})

		}

	}

}
